import { makeActionFactory } from './actionFactory';
import { PolicyMap } from 'types';

export type ActionType =
    'POLICIES_LOAD_REQUEST'
    | 'POLICIES_LOAD_SUCCESS'
    | 'POLICIES_LOAD_FAILURE'
    | 'POLICIES_CHANGED'
;

const actionFactory = makeActionFactory<ActionType>();


//
//  POLICIES_LOAD_REQUEST action notifies the app that we're trying to load policies
//
export interface PoliciesLoadRequestAction {
    type: 'POLICIES_LOAD_REQUEST';
}
export const policiesLoadRequest = actionFactory.empty<PoliciesLoadRequestAction>('POLICIES_LOAD_REQUEST');


//
//  POLICIES_LOAD_SUCCESS action notifies the app that we successfully loaded policies
//
export interface PoliciesLoadSuccessAction {
    type: 'POLICIES_LOAD_SUCCESS';
    payload: PolicyMap;
}
export const policiesLoadSuccess = actionFactory.payload<PoliciesLoadSuccessAction, PolicyMap>('POLICIES_LOAD_SUCCESS');


//
//  POLICIES_LOAD_FAILURE action notifies the app that we failed to load policies
//
export interface PoliciesLoadFailureAction {
    type: 'POLICIES_LOAD_FAILURE';
    payload: Error;
    error: true;
}
export const policiesLoadFailure = actionFactory.error<PoliciesLoadFailureAction>('POLICIES_LOAD_FAILURE');


//
//  POLICIES_CHANGED action notifies the app that policies have changed
//  (asynchronously via server push rather than us loading them)
//
export type PolicyDelta = {}; // TODO: ...
export interface PoliciesChangedAction {
    type: 'POLICIES_CHANGED';
    payload: PolicyDelta[];
}
export const policiesChanged = actionFactory.payload<PoliciesChangedAction, PolicyDelta[]>('POLICIES_CHANGED');



// WEBPACK FOOTER //
// ./src/actions/policyActions.ts